<div class="home-center">
    <!--p>Client Text:</p>
    <div class="p-inputgroup p-mb-2" *ngIf="config !== undefined">
        <input #clientText id="clientText" type="text" pInputText placeholder="Text" 
                aria-describedby="clientText-help" autocorrect="off" spellcheck="false" autocomplete="on"
                [(ngModel)]="config.text">
    </div>

    <table *ngIf="config !== undefined" style="width: 100%;">
        <tr>
            <th style="width:300px">Feature</th>
            <th>Enabled</th>
        </tr>
        <tr>
            <td>AR</td>
            <td style="width: 100px;"><input type="checkbox" [(ngModel)]="config.ar"/></td>
        </tr>
        <tr>
            <td>Map</td>
            <td><input type="checkbox" [(ngModel)]="config.map"/></td>
        </tr>
        <tr>
            <td>Video</td>
            <td><input type="checkbox" [(ngModel)]="config.video"/></td>
        </tr>
        <tr>
            <td>Gallery</td>
            <td><input type="checkbox" [(ngModel)]="config.gallery"/></td>
        </tr>
        <tr>
            <td>TTS</td>
            <td><input type="checkbox" [(ngModel)]="config.tts"/></td>
        </tr>
    </table>

    <p>Client Logo:</p>
    <p-fileUpload #fileUpload multiple="multiple" accept="image/*" maxFileSize="10000000" [fileLimit]="maxContent" 
                                [showUploadButton]="false" [showCancelButton]="false" (onSelect)="onFilesSelect($event)"
                                styleClass="{{(attachments.length > maxContent) ? 'error-files' : ''}}">
                    
                </p-fileUpload>
                
                <div class="p-d-flex p-ai-center p-flex-column p-mt-4" *ngIf="downloadURL | async; let url">
                    <img [src]="url" alt="Image from AngularFireStorage">
                </div>
    <div class="p-d-flex p-jc-end p-p-2">
        <button pButton pRipple type="button" icon="pi pi-save" (click)="save()" class="p-button-rounded" label="Save"></button>
    </div-->

    <p-confirmPopup></p-confirmPopup>
    <p-toast></p-toast>
</div>